import type { DefaultTheme } from 'styled-components';

const indicatorStatusColor = (indicatorStatus: string, theme: DefaultTheme) => {
  const { colors: { variant: { darker: themeColors } } } = theme;
  const defaultColor = themeColors.info;
  const colorMapping = {
    danger: themeColors.danger,
    info: themeColors.info,
    success: themeColors.success,
    warning: themeColors.warning,
  };

  return colorMapping[indicatorStatus] ?? defaultColor;
};

export default indicatorStatusColor;
